import { Calendar } from "lucide-react";
import { ListItemBadge } from "@components/ListItemCardCst/types";
import { EnrolledUserItem } from "../types";
import { resolveExpirationBadge } from "./enrollmentExpiration";

export const buildExpirationBadge = (
  user: EnrolledUserItem,
  expiredLabel: string,
): ListItemBadge | null => {
  const info = resolveExpirationBadge(user);
  if (!info) return null;
  return {
    variant: info.variant,
    icon: <Calendar size={14} />,
    label: info.isExpired ? `${expiredLabel}: ${info.date}` : info.date,
  };
};
